class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.rootLinks = Array.from(this.querySelectorAll('li'));
    this.hoverIntentListeners = null;
    this.onMouseOver = this.handleMouseOver.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  bindEvents() {
    if (typeof window.hoverintent !== 'undefined') {
      const main = hoverintent(this, this.onMouseOver, () => { });
      main.options({ interval: 50 });
      this.hoverIntentListeners = { main };
    } else {
      this.addEventListener('mouseenter', this.onMouseOver);
    }

    this.querySelector('summary').addEventListener('click', this.handleSummaryClick);
    this.header.addEventListener('mouseleave', this.onClose);
  }

  handleSummaryClick(event) {
    const innerLink = event.currentTarget.querySelector('a');
    if (innerLink) return;

    event.preventDefault();
  }

  unbindEvents() {
    if (this.hoverIntentListeners) {
      this.hoverIntentListeners.main.remove();
    } else {
      this.removeEventListener('mouseenter', this.onMouseOver);
    }
  }

  handleMouseOver() {
    this.open();
  }

  onClose() {
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
